<template>
	<app-modal v-if="show" @close="closeModal" title="" @click.stop="">
		<template v-slot:header>
			<span class="mr-2">
				{{ categoryData.id ? 'Update Category' : 'Create Category' }}
			</span>
		</template>
		<div style="width: 350px;">
			<div class="flex flex-1 flex-col items-center justify-center mb-2 mx-2 px-2">
				<div class="mb-2">
					<add-icon-component
						:image="categoryData.imageUrl"
						:aspect-ratio="1"
						@on-select="categoryData.imageUrl = $event"
						@on-crop="categoryData.imageUrl = $event"
					/>
				</div>
				<app-input
					name="Name"
					placeholder="Name"
					v-model="categoryData.categoryName"
					class="w-full flex flex-1"
				/>
				<app-button
					class="btn btn-success float-right"
					@click="submit"
					:loading="submitting"
					:disabled="!categoryData.categoryName"
				>
					{{ categoryData.id ? 'Save' : 'Create' }}
				</app-button>
			</div>
		</div>
	</app-modal>
</template>

<script>
	import AppModal from '@/components/app/AppModal';
	import AppInput from '@/components/app/AppInput';
	import AppButton from '@/components/app/AppButton';
	import CategoriesService from '../../services/sales/CategoriesService';
	import AddIconComponent from '@/components/marketing/forms/formComponents/AddIconComponent';

	export default {
		name: 'MenuCategoryModal',
		components: { AddIconComponent, AppButton, AppInput, AppModal },
		emits: ['close'],
		props: {
			category: {
				required: true,
				type: Object,
			},
			show: {
				required: true,
				type: Boolean,
			},
		},
		data: () => ({
			categoryData: {},
			submitting: false,
		}),
		methods: {
			prepareCategoryData() {
				this.categoryData = { ...this.category };
			},
			closeModal(data) {
				this.$emit('close', data);
			},
			submit() {
				this.submitting = true;
				const payload = {
					categoryName: this.categoryData.categoryName,
					status: 1,
					imageJson: { stringBase64: this.categoryData.imageUrl },
				};
				CategoriesService.createOrUpdateMenuCategory(payload)
					.then((cat) => {
						this.$emit(this.categoryData.id ? 'updated' : 'created', cat);
						this.closeModal();
					})
					.catch((err) => {
						this.$notificationService.error(err);
					})
					.finally(() => {
						this.submitting = false;
					});
			},
		},
		mounted() {
			this.prepareCategoryData();
		},
	};
</script>
